/**
 * @generated SignedSource<<3bfa8c4325459ff8082cddf0500657b9>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type LandlordDirectoryPortal = "ON_THE_MARKET" | "RIGHTMOVE" | "ZOOPLA" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type DirectoryAgentHero_agent$data = {
  readonly areas: ReadonlyArray<{
    readonly slug: string | null | undefined;
  }> | null | undefined;
  readonly enrichedAt: string | null | undefined;
  readonly fees: {
    readonly feesIncludeVat: boolean | null | undefined;
    readonly management: {
      readonly amountPence: number | null | undefined;
      readonly percent: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly googleRating: number | null | undefined;
  readonly googleReviewCount: number | null | undefined;
  readonly logoUrl: string | null | undefined;
  readonly name: string | null | undefined;
  readonly openedYear: number | null | undefined;
  readonly portalListings: ReadonlyArray<{
    readonly listingCount: number | null | undefined;
    readonly portal: LandlordDirectoryPortal | null | undefined;
  }> | null | undefined;
  readonly postcode: string | null | undefined;
  readonly services: ReadonlyArray<string> | null | undefined;
  readonly slug: string | null | undefined;
  readonly " $fragmentType": "DirectoryAgentHero_agent";
};
export type DirectoryAgentHero_agent$key = {
  readonly " $data"?: DirectoryAgentHero_agent$data;
  readonly " $fragmentSpreads": FragmentRefs<"DirectoryAgentHero_agent">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DirectoryAgentHero_agent",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postcode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "openedYear",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "services",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleRating",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "googleReviewCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enrichedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LandlordDirectoryAreaReference",
      "kind": "LinkedField",
      "name": "areas",
      "plural": true,
      "selections": [
        (v0/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LandlordDirectoryPortalListing",
      "kind": "LinkedField",
      "name": "portalListings",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "portal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "listingCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LandlordDirectoryAgentFees",
      "kind": "LinkedField",
      "name": "fees",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LandlordDirectoryAgentFee",
          "kind": "LinkedField",
          "name": "management",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "percent",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amountPence",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "feesIncludeVat",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LandlordDirectoryAgent",
  "abstractKey": null
};
})();

(node as any).hash = "51b85abf8cfc0a81f8164eaf9b6f9f6b";

export default node;
